export default __webpack_public_path__ + "static/media/Laser_0003_Laser-impact.486baf33.png";